// Dónde está cada insumo: en la bodega o en un ruta.
//
// Hasta ahora había UNA existencia: lo comprado menos lo usado. Servía mientras
// todo se guardaba en el mismo sitio. Pero este cliente manda bultos de sal a
// sus rutas, y desde ahí la existencia global no dice nada útil: puede decir
// «quedan 5 bultos» estando los cinco a dos horas de camino de la ruta que se
// quedó sin sal esta mañana.
//
// ── Lo que un envío NO es ──
//
// No es una compra ni un gasto: es la misma sal cambiando de sitio. No toca el
// costo ni la existencia total. Tres bultos parados en una ruta siguen siendo
// plata suya — se vuelven gasto el día que entran a la tina, no el día que se
// suben al carro.

const num = (x) => {
  const n = Number(x);
  return Number.isFinite(n) ? n : 0;
};

// Lo que queda en la bodega principal.
//
//   comprado − enviado − lo usado en cuajadas SIN centro anotado
//
// Lo usado sin centro sale de la bodega porque es donde estaba: si nadie anotó
// centro, la cuajada se hizo en la planta.
export function enBodega(insumo) {
  if (!insumo) return 0;
  return num(insumo.comprado) - num(insumo.enviado) - num(insumo.usado_bodega);
}

// Lo que queda en una ruta: lo que se le mandó menos lo que gastó.
export function enRuta(fila) {
  if (!fila) return 0;
  return num(fila.enviado) - num(fila.usado);
}

// Todo lo que hay de un insumo, sitio por sitio, con la bodega primero.
//
// La bodega va primero siempre, incluso en cero: es de donde se manda, y una
// lista que la esconde cuando está vacía obliga a adivinar por qué no aparece.
export function porSitio(insumo, filasDeRutas) {
  if (!insumo) return [];
  const sitios = [{
    id: null, nombre: 'Bodega principal', esBodega: true,
    queda: enBodega(insumo), enviado: null, usado: num(insumo.usado_bodega),
  }];
  for (const f of filasDeRutas || []) {
    if (f.insumo_id !== insumo.id) continue;
    sitios.push({
      id: f.centro_id, nombre: f.centro, esBodega: false,
      queda: enRuta(f), enviado: num(f.enviado), usado: num(f.usado),
    });
  }
  return sitios;
}

// LA COMPROBACIÓN QUE TIENE QUE CUADRAR.
//
// La suma de todos los sitios tiene que dar la existencia total. Si no cuadra,
// hay plata perdida en alguna cuenta y más vale decirlo que pintar una tabla
// bonita que no suma.
export function cuadra(insumo, filasDeRutas) {
  if (!insumo) return true;
  const suma = porSitio(insumo, filasDeRutas).reduce((s, x) => s + x.queda, 0);
  const total = num(insumo.comprado) - num(insumo.usado);
  return Math.abs(suma - total) < 0.01;
}

// Los sitios donde se está acabando, para poder avisar antes y no después.
//
// Un centro sin nada no es lo mismo que una ruta con poco: el primero ya
// paró. Van los dos, pero separados.
export function dondeFalta(insumo, filasDeRutas, margen = 0.15) {
  // CADA SITIO SE MIDE CONTRA LO QUE PASÓ POR ÉL, no contra el total comprado.
  //
  // La primera versión comparaba todo contra lo comprado en total, y entonces
  // una ruta chico —al que se le mandan dos bultos— salía «se está acabando»
  // teniendo sal de sobra, solo porque dos bultos son poco al lado de diez. Un
  // aviso que salta cuando no pasa nada se deja de leer, y el día que una ruta
  // sí se quede sin sal ese aviso tampoco se lee.
  return porSitio(insumo, filasDeRutas)
    .map(x => {
      const paso = x.esBodega ? num(insumo.comprado) : num(x.enviado);
      return { ...x, paso, vacio: x.queda <= 0 };
    })
    .filter(x => x.vacio ? x.paso > 0 : (x.paso > 0 && x.queda <= x.paso * margen));
}
